'use client';

import DraftModeToggler from '@/components/DraftModeToggler';
import { useEffect, useState } from 'react';

// Client-side draft detection so the layout that renders this stays static
// (no server-side draftMode() call). The enable/disable API routes set/clear a
// non-httpOnly `cleanor-draft` cookie that we read here.
export default function DraftModeBanner() {
  const [draftEnabled, setDraftEnabled] = useState(false);

  useEffect(() => {
    setDraftEnabled(document.cookie.split('; ').some((entry) => entry === 'cleanor-draft=1'));
  }, []);

  if (!draftEnabled) {
    return null;
  }

  return (
    <div className="draft-toggle-shell">
      <DraftModeToggler draftModeEnabled />
    </div>
  );
}
